import { RootState } from 'store';

export const getOrganization = (state: RootState) =>
  state.organization.organization;

export const getIsOrganizationChoice = (state: RootState) =>
  state.organization.isOrganizationChoice;
